export default __webpack_public_path__ + "static/media/cv.d2db3421.svg";